var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Bowser from 'bowser';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
let UserAgent = class UserAgent {
    constructor() {
        /**
         * 环境设备信息
         * @memberof AppConfig
         */
        this.Parsed = Bowser.parse(window.navigator.userAgent);
        /**
         * Android
         * @readonly
         * @memberof XTGlobal
         */
        this.isAndroid = lodash.eq(this.Parsed.os.name, Bowser.OS_MAP.Android);
        /**
         * iOS
         * @readonly
         * @memberof XTGlobal
         */
        this.isiOS = lodash.eq(this.Parsed.os.name, Bowser.OS_MAP.iOS);
        /**
         * Windows
         * @readonly
         * @memberof XTGlobal
         */
        this.isWindows = lodash.eq(this.Parsed.os.name, Bowser.OS_MAP.Windows);
        /**
         * Mac
         * @readonly
         * @memberof XTGlobal
         */
        this.isMac = lodash.eq(this.Parsed.os.name, Bowser.OS_MAP.MacOS);
        /**
         * 桌面
         * @readonly
         * @memberof XTGlobal
         */
        this.isDesktop = lodash.eq(this.Parsed.platform.type, Bowser.PLATFORMS_MAP.desktop);
        /**
         * 手机
         * @readonly
         * @memberof XTGlobal
         */
        this.isMobile = lodash.eq(this.Parsed.platform.type, Bowser.PLATFORMS_MAP.mobile);
        /**
         * 平板电脑
         * @readonly
         * @memberof XTGlobal
         */
        this.isTablet = lodash.eq(this.Parsed.platform.type, Bowser.PLATFORMS_MAP.tablet);
        /**
         * 微信浏览器
         * @readonly
         * @memberof XTGlobal
         */
        this.isWechatBowser = lodash.eq(this.Parsed.browser.name, Bowser.BROWSER_MAP.wechat);
    }
};
UserAgent = __decorate([
    BindAll()
], UserAgent);
export { UserAgent };
